var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('a',{staticClass:"text-primary",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.url.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.params.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }